$('.the-solution__contents').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  infinite: false,
  responsive: [
    {
      breakpoint: 581,
      settings: {
        slidesToShow: 1,
        infinite: true,
      }
    },
  ]
});